<template>
  <div>
    <a-modal v-model="viewModal" :closable="false" :maskClosable="false">
      <a-result>
        <template #icon>
          <a-icon type="file-excel" theme="twoTone" />
        </template>
        <template #extra>
          <h3 :style="{ margin: '10px 0' }">Import Alumni Data</h3>
          <span v-for="(item, index) in listTypeData">
            <a-button class="mb-10" shape="round" @click="onSelectedImport(item.component)" block>
              <a-icon :type="item.icon" class="mr-10" theme="outlined" />
              {{ item.text }}
            </a-button>
          </span>
        </template>
      </a-result>
      <template slot="footer">
        <a-row>
          <a-col :span="12" class="text-left">
          </a-col>
          <a-col :span="12">
            <a-button type="danger" @click="onCloseModal"> close </a-button>
          </a-col>
        </a-row>
      </template>
    </a-modal>
  </div>
</template>

<script>
export default {
  props: {
    viewModal: {
      type: Boolean,
      default: false,
    },
    onShowModal: { type: Function },
    onCloseModal: { type: Function },
  },
  data() {
    return {
      listTypeData: [
        { icon: "user", text: "Alumni Profile", component: 'importAlumniProfile' },
        { icon: "file-text", text: "Update Name", component: 'importAlumniName' },
        { icon: "contacts", text: "Update Contact", component: 'importAlumniContact' },
        { icon: "read", text: "Update Futher Education", component: 'importAlumniEducation' },
        { icon: "file-done", text: "Update Work Experience", component: 'importAlumniWorkExperience' },
        { icon: "file-text", text: "Update MUICAA Member", component: 'importAlumniMember' },
      ],
      studentIdCreate: "",
    };
  },
  mounted() { },
  methods: {
    onSelectedImport(typeImport) {
      this.onShowModal(typeImport)
    }
    // onCloseModal() {
    //   this.$emit("onCloseModal");
    // },
  },
};
</script>